import React from 'react';
import { ArrowLeft } from 'lucide-react';
interface PrivacyPolicyProps {
  onBack: () => void;
}
export function PrivacyPolicy({
  onBack
}: PrivacyPolicyProps) {
  return <div className="min-h-screen bg-white" data-id="element-289">
      {/* Header */}
      <div className="sticky top-0 bg-white border-b border-gray-200 z-50" data-id="element-290">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-4" data-id="element-291">
          <button onClick={onBack} className="flex items-center text-gray-600 hover:text-[#00E676] transition-colors" data-id="element-292">
            <ArrowLeft className="w-5 h-5 mr-2" data-id="element-293" />
            Back to Home
          </button>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12" data-id="element-294">
        <div className="space-y-8 text-gray-700 leading-relaxed" data-id="element-295">
          <div data-id="element-296">
            <h1 className="text-4xl font-bold text-gray-900 mb-2" data-id="element-297">
              Privacy Policy
            </h1>
            <p className="text-sm text-gray-600" data-id="element-298">
              Effective Date: December 16, 2025
            </p>
          </div>

          <div className="prose prose-lg max-w-none" data-id="element-299">
            <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4" data-id="element-300">
              BRIXEN FUNDING LLC - PRIVACY POLICY
            </h2>

            <h3 className="text-xl font-bold text-gray-900 mt-6 mb-3" data-id="element-301">
              1. INTRODUCTION
            </h3>
            <p data-id="element-302">
              Brixen Funding LLC ("we," "us," or "our") respects your privacy
              and is committed to protecting your personal data. This Privacy
              Policy explains how we collect, use, disclose, and safeguard your
              information when you visit our website and use our brokerage
              services. By using our Site, you consent to the data practices
              described in this policy.
            </p>

            <h3 className="text-xl font-bold text-gray-900 mt-6 mb-3" data-id="element-303">
              2. INFORMATION WE COLLECT
            </h3>
            <p className="mb-3" data-id="element-304">
              We collect various types of information to facilitate the business
              funding process:
            </p>
            <p className="mb-2" data-id="element-305">
              <strong data-id="element-306">Personal Identification Information:</strong> Name, email
              address, phone number, business address, date of birth, Social
              Security Number (SSN), and driver's license number.
            </p>
            <p className="mb-2" data-id="element-307">
              <strong data-id="element-308">Business & Financial Information:</strong> Business name,
              Employer Identification Number (EIN), business start date,
              industry type, annual revenue, bank statements, tax returns,
              credit card processing statements, and credit history.
            </p>
            <p data-id="element-309">
              <strong data-id="element-310">Technical Usage Data:</strong> IP address, browser type,
              operating system, access times, and pages viewed, collected
              automatically via cookies and tracking technologies.
            </p>

            <h3 className="text-xl font-bold text-gray-900 mt-6 mb-3" data-id="element-311">
              3. HOW WE USE YOUR INFORMATION
            </h3>
            <p className="mb-3" data-id="element-312">
              We use the information we collect for the following business
              purposes:
            </p>
            <p className="mb-2" data-id="element-313">
              <strong data-id="element-314">Funding Facilitation:</strong> To evaluate your
              eligibility for financing and submit your application to our
              network of lenders and Funding Partners.
            </p>
            <p className="mb-2" data-id="element-315">
              <strong data-id="element-316">Communication:</strong> To contact you via email, phone,
              SMS, or WhatsApp regarding your application status, missing
              documents, or offers.
            </p>
            <p className="mb-2" data-id="element-317">
              <strong data-id="element-318">Marketing:</strong> To send you information about new
              funding products, services, or special offers (unless you opt
              out).
            </p>
            <p data-id="element-319">
              <strong data-id="element-320">Security & Compliance:</strong> To verify your identity,
              prevent fraud, and comply with legal obligations (such as KYC and
              AML laws).
            </p>

            <h3 className="text-xl font-bold text-gray-900 mt-6 mb-3" data-id="element-321">
              4. SHARING YOUR INFORMATION & MESSAGING DISCLOSURES
            </h3>
            <p className="mb-3" data-id="element-322">
              As a broker, sharing information is essential to our service. We
              may share your general business data with Funding Partners,
              Service Providers, and Legal Authorities as necessary to secure
              funding.
            </p>
            <p className="mb-3" data-id="element-323">
              However, we adhere to strict standards regarding your mobile data:
            </p>

            <h4 className="text-lg font-bold text-gray-900 mt-4 mb-2" data-id="element-324">
              Data Sharing
            </h4>
            <ul className="list-disc list-inside space-y-2 mb-4" data-id="element-325">
              <li data-id="element-326">
                Customer data is not shared with 3rd parties for promotional or
                marketing purposes.
              </li>
              <li data-id="element-327">
                Mobile opt-in and consent are never shared with anyone for any
                purpose. Any information sharing that may be mentioned elsewhere
                in this policy excludes mobile opt-in data.
              </li>
            </ul>

            <h4 className="text-lg font-bold text-gray-900 mt-4 mb-2" data-id="element-328">
              Messaging Terms and Conditions
            </h4>
            <p data-id="element-329">
              By providing your phone number and agreeing to receive texts, you
              consent to receive text messages from BRIXEN FUNDING LLC, from
              (786) 272-6132 regarding customer care. Consent is not a condition
              of purchase. Message frequency varies. Message & data rates may
              apply. You can reply STOP to unsubscribe at any time or HELP for
              assistance. You can also contact us at (786) 272-6132 or
              info@brixenfunding.com. Mobile opt-in information is never shared
              with third parties.
            </p>

            <h3 className="text-xl font-bold text-gray-900 mt-6 mb-3" data-id="element-330">
              5. COOKIES AND TRACKING TECHNOLOGIES
            </h3>
            <p data-id="element-331">
              We use cookies, web beacons, and similar tracking technologies to
              customize the Site and improve your experience. You can modify
              your browser settings to decline cookies if you prefer, though
              this may limit your use of certain features of the Site.
            </p>

            <h3 className="text-xl font-bold text-gray-900 mt-6 mb-3" data-id="element-332">
              6. DATA SECURITY
            </h3>
            <p data-id="element-333">
              We use administrative, technical, and physical security measures
              including SSL encryption and firewalls to help protect your
              personal information. However, please be aware that no electronic
              transmission over the Internet or information storage technology
              is 100% secure.
            </p>

            <h3 className="text-xl font-bold text-gray-900 mt-6 mb-3" data-id="element-334">
              7. DATA RETENTION
            </h3>
            <p data-id="element-335">
              We will retain your personal information only for as long as is
              necessary for the purposes set out in this Privacy Policy, or as
              required by law.
            </p>

            <h3 className="text-xl font-bold text-gray-900 mt-6 mb-3" data-id="element-336">
              8. YOUR RIGHTS AND OPT-OUT CHOICES
            </h3>
            <p className="mb-2" data-id="element-337">
              <strong data-id="element-338">Marketing Communications:</strong> You can unsubscribe
              from our marketing emails by clicking the "unsubscribe" link in
              the email.
            </p>
            <p className="mb-2" data-id="element-339">
              <strong data-id="element-340">SMS Opt-Out:</strong> As stated above, you may opt out of
              SMS messages at any time by replying "STOP".
            </p>
            <p data-id="element-341">
              <strong data-id="element-342">Access and Correction:</strong> You have the right to
              request copies of your personal data or request that we correct
              any information you believe is inaccurate.
            </p>

            <h3 className="text-xl font-bold text-gray-900 mt-6 mb-3" data-id="element-343">
              9. THIRD-PARTY WEBSITES
            </h3>
            <p data-id="element-344">
              Our Site may contain links to third-party websites (e.g., lender
              portals). This Privacy Policy does not apply to those third-party
              sites. We encourage you to review the privacy policies of any
              third-party site you visit.
            </p>

            <h3 className="text-xl font-bold text-gray-900 mt-6 mb-3" data-id="element-345">
              10. CHILDREN'S PRIVACY
            </h3>
            <p data-id="element-346">
              Our Services are not intended for individuals under the age of 18.
              We do not knowingly collect personal information from children
              under 13.
            </p>

            <h3 className="text-xl font-bold text-gray-900 mt-6 mb-3" data-id="element-347">
              11. CHANGES TO THIS PRIVACY POLICY
            </h3>
            <p data-id="element-348">
              We may update this Privacy Policy from time to time. The updated
              version will be indicated by an updated "Revised" date.
            </p>

            <h3 className="text-xl font-bold text-gray-900 mt-6 mb-3" data-id="element-349">
              12. CONTACT US
            </h3>
            <p className="mb-3" data-id="element-350">
              If you have questions or comments about this Privacy Policy,
              please contact us at:
            </p>
            <div className="bg-gray-50 p-6 rounded-lg border border-gray-200" data-id="element-351">
              <p className="font-semibold text-gray-900" data-id="element-352">Brixen Funding LLC</p>
              <p data-id="element-353">390 NE 191st St</p>
              <p data-id="element-354">Miami, FL 33179</p>
              <p data-id="element-355">(786) 272-6132</p>
              <p data-id="element-356">info@brixenfunding.com</p>
            </div>
          </div>
        </div>
      </div>

      {/* Footer */}
      <div className="bg-gray-50 border-t border-gray-200 py-8 mt-16" data-id="element-357">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-358">
          <button onClick={onBack} className="inline-flex items-center text-[#00E676] hover:text-[#00d169] font-semibold transition-colors" data-id="element-359">
            <ArrowLeft className="w-4 h-4 mr-2" data-id="element-360" />
            Return to Home
          </button>
        </div>
      </div>
    </div>;
}